<!--  -->
<template>
  <div class="tewbox">
    <div class="search_box">
      <el-button type="success" style="margin-bottom:10px" icon="el-icon-plus" @click="addcreat">新增</el-button>
    </div>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="template_name"
        label="模板名称"
        width="180"
        align="center"
      />
      <el-table-column
        prop="template_id_short"
        label="模板编号"
        width="180"
        align="center"
      />
      <el-table-column
        prop="create_time_text"
        label="创建时间"
        align="center"
      />
      <el-table-column
        prop="similar_id"
        label="相似模板编号"
        align="center"
      />
      <el-table-column
        prop="priority_level"
        label="优先级"
        align="center"
      />
      <el-table-column
        prop="address"
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button size="mini" type="warning" @click="edit(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <el-dialog
      title="新增微信模板消息"
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      width="40%"
    >
      <addwechatemplate ref="addmessage" @updata="updata" />
    </el-dialog>
  </div>
</template>

<script>
import { templatemessagelib } from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import addwechatemplate from './components/addwechatemplate.vue'
export default {
  components: {
    PaginationRight,
    addwechatemplate
  },
  data() {
    return {
      query: {
        page: 1,
        pageSize: 10
      },
      tableData: [],
      total: null,
      dialogVisible: false
    }
  },
  created() {
    this.temlist()
  },
  mounted() {

  },
  methods: {
    async temlist() {
      const data = await templatemessagelib(this.query)
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      this.query.pageSize = e
      this.temlist()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.temlist()
    },
    edit(row) {
      console.log('row', row)
      this.dialogVisible = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.addmessage.sendrs(2, row)
      }, 100)
    },
    addcreat() {
      this.dialogVisible = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.addmessage.sendrs(1)
      }, 100)
    },
    updata() {
      this.dialogVisible = false
      this.temlist()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.tewbox{
  padding: 30px;
}
.search_box{
  text-align: right;
}
</style>
